import Accordion from '../util/accordion';

class Filters {
  constructor(el) {
    this.el = el;
    this.filters = this.el.querySelectorAll('[data-accordion]');
    this.init();
  }
  init() {
    new Accordion(this.el);
    Array.from(this.filters).forEach((element) => {
      new Accordion(element);
    });
  }
}

export default Filters;
